module.exports = __webpack_public_path__ + "static/media/CloseIcon.6abdf7bc.svg";